// extracted by mini-css-extract-plugin
export default {"parent-mode":"back-header_parent-mode__Rh8P5","backHeader":"back-header_backHeader__YhRCg","title":"back-header_title__+e4ap","space":"back-header_space__0Dg3j"};